export enum PlannerDashboardType {
    DigitalVideo = "digital-video",
    IOPreview = "insertion-order-preview"
}